import { render, staticRenderFns } from "./netteach-standard.vue?vue&type=template&id=057e1af6"
import script from "./netteach-standard.vue?vue&type=script&lang=js"
export * from "./netteach-standard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports